import { Gender } from 'src/constants/common';
import { EducationLevelGroup } from '../school';

export const TODAY = new Date();
export const MIN_SERVICE_END_DATE = new Date(TODAY.getFullYear(), TODAY.getMonth() - 1, 1);

export const ChildGenderList = [
    { id: Gender.FEMALE, name: 'Дівчинка' },
    { id: Gender.MALE, name: 'Хлопчик' },
    { id: Gender.OTHER, name: 'Інше' }
];

export enum EducationAction {
    REMOTE = 'REMOTE',
    EXTERNAL = 'EXTERNAL',
    PEDAGOGICAL = 'PEDAGOGICAL',
    PATRONAGE = 'PATRONAGE'
}

export const AdditionalEducationActionList = [
    { id: EducationAction.REMOTE, name: 'Дистанційна' },
    { id: EducationAction.EXTERNAL, name: 'Екстернатна' },
    { id: EducationAction.PEDAGOGICAL, name: 'Педагогічна' },
    { id: EducationAction.PATRONAGE, name: 'Патронажна' }
];

export enum EducationLevel {
    YEARS4 = 'YEARS4',
    YEARS5 = 'YEARS5',
    YEARS6 = 'YEARS6',
    GRADE1 = 'GRADE1',
    GRADE2 = 'GRADE2',
    GRADE3 = 'GRADE3',
    GRADE4 = 'GRADE4',
    GRADE5 = 'GRADE5',
    GRADE6 = 'GRADE6',
    GRADE7 = 'GRADE7',
    GRADE8 = 'GRADE8',
    GRADE9 = 'GRADE9',
    GRADE10 = 'GRADE10',
    GRADE11 = 'GRADE11'
}

export const EducationLevelGroupShortName = {
    [EducationLevelGroup.HIGH_SCHOOL]: 'Базова та старша',
    [EducationLevelGroup.JUNIOR_SCHOOL]: 'Початкова',
    [EducationLevelGroup.PRESCHOOL]: 'Дошкільна'
} as const;
type EducationLevelGroupShortNameKeys = keyof typeof EducationLevelGroupShortName;
export type EducationLevelGroupShortNameValues =
    (typeof EducationLevelGroupShortName)[EducationLevelGroupShortNameKeys];

export const EducationLevelGroupFullName = {
    [EducationLevelGroup.HIGH_SCHOOL]: 'Базова та старша (5-11 клас)',
    [EducationLevelGroup.JUNIOR_SCHOOL]: 'Початкова (1-4 клас)',
    [EducationLevelGroup.PRESCHOOL]: 'Дошкільна (від 3 до 6+ років)'
} as const;
type EducationLevelGroupFullNameKeys = keyof typeof EducationLevelGroupFullName;
export type EducationLevelGroupFullNameValues = (typeof EducationLevelGroupFullName)[EducationLevelGroupFullNameKeys];

export interface EducationLevelGroupData {
    id: EducationLevelGroup;
    shortName: EducationLevelGroupShortNameValues;
    fullName: EducationLevelGroupFullNameValues;
}

export const EducationLevelList = [
    { id: EducationLevel.YEARS4, name: 'Дошкільна - 3-4 роки' },
    { id: EducationLevel.YEARS5, name: 'Дошкільна - 5 років' },
    { id: EducationLevel.YEARS6, name: 'Дошкільна - 6+ років' },
    { id: EducationLevel.GRADE1, name: '1 клас' },
    { id: EducationLevel.GRADE2, name: '2 клас' },
    { id: EducationLevel.GRADE3, name: '3 клас' },
    { id: EducationLevel.GRADE4, name: '4 клас' },
    { id: EducationLevel.GRADE5, name: '5 клас' },
    { id: EducationLevel.GRADE6, name: '6 клас' },
    { id: EducationLevel.GRADE7, name: '7 клас' },
    { id: EducationLevel.GRADE8, name: '8 клас' },
    { id: EducationLevel.GRADE9, name: '9 клас' },
    { id: EducationLevel.GRADE10, name: '10 клас' },
    { id: EducationLevel.GRADE11, name: '11 клас' }
];

export const EducationGroupLevelList = [
    {
        id: EducationLevelGroup.HIGH_SCHOOL,
        name: EducationLevelGroupShortName[EducationLevelGroup.HIGH_SCHOOL]
    },
    {
        id: EducationLevelGroup.JUNIOR_SCHOOL,
        name: EducationLevelGroupShortName[EducationLevelGroup.JUNIOR_SCHOOL]
    },
    {
        id: EducationLevelGroup.PRESCHOOL,
        name: EducationLevelGroupShortName[EducationLevelGroup.PRESCHOOL]
    }
];

export const NoValuePlaceholder = '-';

export const EducationLevelTableList = [
    { id: EducationLevel.YEARS4, name: NoValuePlaceholder },
    { id: EducationLevel.YEARS5, name: NoValuePlaceholder },
    { id: EducationLevel.YEARS6, name: NoValuePlaceholder },
    ...EducationLevelList.slice(2)
];

export const EducationLevelGroupList: Record<EducationLevelGroup, { id: EducationLevel; name: string }[]> = {
    [EducationLevelGroup.HIGH_SCHOOL]: [
        { id: EducationLevel.GRADE5, name: '5 клас' },
        { id: EducationLevel.GRADE6, name: '6 клас' },
        { id: EducationLevel.GRADE7, name: '7 клас' },
        { id: EducationLevel.GRADE8, name: '8 клас' },
        { id: EducationLevel.GRADE9, name: '9 клас' },
        { id: EducationLevel.GRADE10, name: '10 клас' },
        { id: EducationLevel.GRADE11, name: '11 клас' }
    ],
    [EducationLevelGroup.JUNIOR_SCHOOL]: [
        { id: EducationLevel.GRADE1, name: '1 клас' },
        { id: EducationLevel.GRADE2, name: '2 клас' },
        { id: EducationLevel.GRADE3, name: '3 клас' },
        { id: EducationLevel.GRADE4, name: '4 клас' }
    ],
    [EducationLevelGroup.PRESCHOOL]: [
        { id: EducationLevel.YEARS4, name: 'Дошкільна - 3-4 роки' },
        { id: EducationLevel.YEARS5, name: 'Дошкільна - 5 років' },
        { id: EducationLevel.YEARS6, name: 'Дошкільна - 6+ років' }
    ]
};

export const EducationLevelGroupDropdownList: Record<
    EducationLevelGroup,
    { id: EducationLevel; name: string; shortName?: string }[]
> = {
    ...EducationLevelGroupList,
    [EducationLevelGroup.PRESCHOOL]: [
        { id: EducationLevel.YEARS4, name: '3-4 роки' },
        { id: EducationLevel.YEARS5, name: '5 років' },
        { id: EducationLevel.YEARS6, name: '6+ років' }
    ]
};

export const HighSchoolEducationLevels = [
    EducationLevel.GRADE5,
    EducationLevel.GRADE6,
    EducationLevel.GRADE7,
    EducationLevel.GRADE8,
    EducationLevel.GRADE9,
    EducationLevel.GRADE10,
    EducationLevel.GRADE11
];

export const JuniorSchoolEducationLevels = [
    EducationLevel.GRADE1,
    EducationLevel.GRADE2,
    EducationLevel.GRADE3,
    EducationLevel.GRADE4
];

export const PreSchoolEducationLevels = [EducationLevel.YEARS4, EducationLevel.YEARS5, EducationLevel.YEARS6];

export enum PreschoolAgeLevel {
    AGE3 = 'AGE3',
    AGE4 = 'AGE4',
    AGE5 = 'AGE5',
    AGE6 = 'AGE6'
}

export const PreschoolAgeLevelList = [
    { id: PreschoolAgeLevel.AGE3, name: '3' },
    { id: PreschoolAgeLevel.AGE4, name: '4' },
    { id: PreschoolAgeLevel.AGE5, name: '5' },
    { id: PreschoolAgeLevel.AGE6, name: '6' }
];

export enum SpecialEducationRequirements {
    ALTERNATIVE_COMMUNICATION = 'ALTERNATIVE_COMMUNICATION',
    SIGN_LANGUAGE = 'SIGN_LANGUAGE',
    SPEECH_THERAPIST = 'SPEECH_THERAPIST',
    PSYCHOLOGIST = 'PSYCHOLOGIST',
    BRAILLE = 'BRAILLE',
    OTHER = 'OTHER'
}

export const SpecialEducationRequirementsList = [
    { id: SpecialEducationRequirements.ALTERNATIVE_COMMUNICATION, name: 'Альтернативні засоби комунікації' },
    { id: SpecialEducationRequirements.SIGN_LANGUAGE, name: 'Жестова мова' },
    { id: SpecialEducationRequirements.SPEECH_THERAPIST, name: 'Логопед-дефектолог' },
    { id: SpecialEducationRequirements.PSYCHOLOGIST, name: 'Фахівець ППП' },
    { id: SpecialEducationRequirements.BRAILLE, name: 'Шрифт Брайля' }
];

export enum DisabilityGroup {
    GROUP1 = 'GROUP1',
    GROUP2 = 'GROUP2',
    GROUP3 = 'GROUP3'
}

export const DisabilityGroupList = [
    { id: DisabilityGroup.GROUP1, name: 'І група' },
    { id: DisabilityGroup.GROUP2, name: 'ІІ група' },
    { id: DisabilityGroup.GROUP3, name: 'ІІІ група' },
    { id: 'NO_DATA', name: 'Не вказано / Немає даних' }
];

export enum DisabilityReason {
    DISEASE = 'DISEASE',
    INJURIES = 'INJURIES',
    CONGENITAL = 'CONGENITAL'
}

export const DisabilityReasonList = [
    { id: DisabilityReason.DISEASE, name: 'Захворювання' },
    { id: DisabilityReason.INJURIES, name: 'Травми їх наслідки' },
    { id: DisabilityReason.CONGENITAL, name: 'Вроджені порушення' },
    { id: 'NO_DATA', name: 'Не вказано / Немає даних' }
];

export enum ChildFormFields {
    ID = 'id',
    VERSION = 'version',

    BIRTH_CERTIFICATE_ID = 'birthCertificateId',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    PATRONYMIC = 'patronymic',
    BIRTH_DATE = 'birthDate',
    GENDER = 'gender',
    RESIDENCE = 'actualAddress',
    REGISTRATION = 'registrationAddress',

    EDUCATIONAL_INSTITUTION_REFERENCE = 'educationInstitutionUrl',
    EDUCATIONAL_INSTITUTION_PHONE = 'educationInstitutionPhone',
    EDUCATIONAL_INSTITUTION_EMAIL = 'educationInstitutionEmail',
    EDUCATIONAL_INSTITUTION_ADDITIONAL_ACTION = 'additionalActionRequired',

    VISIT = 'visit',
    VISIT_HISTORY = 'visitHistory',
    VISITORS = 'visitParents',
    PARENT = 'parent',
    VISITOR_TAX_NUMBER = 'taxNumber',
    VISITOR_FIRST_NAME = 'name',
    VISITOR_LAST_NAME = 'surname',
    VISITOR_PATRONYMIC = 'patronymic',
    VISITOR_EMAIL = 'email',
    VISITOR_PHONE = 'phone',
    VISITOR_ROLE = 'role',
    VISITOR_ACTIVE = 'active',

    EDUCATIONAL_LEVEL = 'educationLevel',
    EDUCATIONAL_GROUP_LEVEL = 'educationLevelGroup',
    PRESCHOOL_AGE_LEVEL = 'preschoolAgeLevel',
    EDUCATION_CENTER = 'educationCenterId',
    EDUCATION_CENTER_DATA = 'educationCenter',
    HOSPITAL_DEPARTMENT_DATA = 'hospitalDepartment',
    HOSPITAL_DEPARTMENT = 'hospitalDepartmentId',
    EDUCATIONAL_AGREEMENT_DATE = 'servicesAgreementDate',
    EDUCATIONAL_SERVICE_END = 'servicesEndDate',
    EDUCATIONAL_SPECIAL_REQUIREMENTS = 'specialRequirements',
    OTHER_SPECIAL_REQUIREMENTS = 'otherSpecialRequirements',
    DISABILITY = 'disabilityPresent',
    DISABILITY_GROUP = 'disabilityGroup',
    DISABILITY_REASON = 'disabilityReason',
    ORPHAN = 'orphan',
    DISPLACED = 'internallyDisplaced',
    WAR_VICTIM = 'warVictim',
    COMPLICATED_LIFE_CIRCUMSTANCES = 'complicatedLifeCircumstances',
    OTHER_SOCIAL_STATUS = 'otherSocialStatus',
    MEDIA_RECORDING_AGREEMENT = 'mediaRecordingAgreement',
    MEDIA_RECORDING_LINK = 'mediaRecordingLink',
    CHILD_INFO = 'info'
}

export const ChildFormDefaults = {
    // [ChildFormFields.ID]: 0,
    [ChildFormFields.VERSION]: 0,
    [ChildFormFields.BIRTH_CERTIFICATE_ID]: '',
    [ChildFormFields.FIRST_NAME]: '',
    [ChildFormFields.LAST_NAME]: '',
    [ChildFormFields.PATRONYMIC]: '',
    [ChildFormFields.BIRTH_DATE]: '',
    [ChildFormFields.GENDER]: Gender.FEMALE,
    [ChildFormFields.VISIT]: {
        [ChildFormFields.RESIDENCE]: '',
        [ChildFormFields.REGISTRATION]: '',
        [ChildFormFields.EDUCATIONAL_INSTITUTION_REFERENCE]: '',
        [ChildFormFields.EDUCATIONAL_INSTITUTION_PHONE]: '',
        [ChildFormFields.EDUCATIONAL_INSTITUTION_EMAIL]: '',
        [ChildFormFields.EDUCATIONAL_INSTITUTION_ADDITIONAL_ACTION]: {
            enabled: false,
            action: null
        },
        [ChildFormFields.VISITORS]: [
            {
                [ChildFormFields.PARENT]: {
                    [ChildFormFields.VISITOR_TAX_NUMBER]: '',
                    [ChildFormFields.VISITOR_FIRST_NAME]: '',
                    [ChildFormFields.VISITOR_LAST_NAME]: '',
                    [ChildFormFields.VISITOR_PATRONYMIC]: '',
                    [ChildFormFields.VISITOR_EMAIL]: '',
                    [ChildFormFields.VISITOR_PHONE]: ''
                },
                [ChildFormFields.VISITOR_ROLE]: '',
                [ChildFormFields.VISITOR_ACTIVE]: false
            }
        ],
        [ChildFormFields.EDUCATIONAL_LEVEL]: null,
        [ChildFormFields.PRESCHOOL_AGE_LEVEL]: null,
        [ChildFormFields.EDUCATION_CENTER]: null,
        [ChildFormFields.HOSPITAL_DEPARTMENT]: null,
        [ChildFormFields.EDUCATIONAL_AGREEMENT_DATE]: '',
        [ChildFormFields.EDUCATIONAL_SERVICE_END]: null,
        [ChildFormFields.EDUCATIONAL_SPECIAL_REQUIREMENTS]: {
            enabled: false,
            parameters: []
        },
        [ChildFormFields.DISABILITY]: false,
        [ChildFormFields.DISABILITY_GROUP]: null,
        [ChildFormFields.DISABILITY_REASON]: null,
        [ChildFormFields.ORPHAN]: false,
        [ChildFormFields.DISPLACED]: false,
        [ChildFormFields.WAR_VICTIM]: false,
        [ChildFormFields.COMPLICATED_LIFE_CIRCUMSTANCES]: false,
        [ChildFormFields.OTHER_SOCIAL_STATUS]: '',
        [ChildFormFields.MEDIA_RECORDING_AGREEMENT]: false,
        [ChildFormFields.MEDIA_RECORDING_LINK]: null,
        [ChildFormFields.CHILD_INFO]: ''
    }
};

export const SocialStatusLabels = {
    [ChildFormFields.ORPHAN]: 'Дитина сирота чи дитина позбавлена батьківського піклування',
    [ChildFormFields.DISPLACED]: 'Дитина ВПО',
    [ChildFormFields.WAR_VICTIM]: 'Має статус постаждалих в наслідок воєнних дій та збройних конфліктів',
    [ChildFormFields.COMPLICATED_LIFE_CIRCUMSTANCES]: 'Складні життєві обставини'
};
